


const milliSinceEpoch = Date.now();
let _scrollTriggerLoaded = false;

const checkIsLoded = (object, objectProperty) => {
	return (window?.[object] && window[object]?.[objectProperty]) !== undefined;
}

async function loadVersion() {

	try {
		const response = await fetch('https://dev.fswdesign.com/wp-content/themes/fsw2025/dist/js/version.js?=' + milliSinceEpoch);
		if (!response.ok) {
			throw new Error('Failed to fetch file');
		}
		const fileContent = await response.text();
		//BundleVersion = fileContent;
		// console.log("LoadedBundleVersion: ", BundleVersion);
		return BundleVersion;
		//_init();
		// Rest of the script can run here
	} catch (error) {
		console.error(error);
		return '';
		//_init();
	}
}
const BundleVersion = milliSinceEpoch; //await loadVersion();


export const hashCode = strVal => {
	const str = strVal.toString();
	let hash = 0;
	// const length = outputLength < 5 ? 5 : outputLength

	for (let i = 0; i < str.length; i++) {
		hash = ((hash << 5) - hash + str.charCodeAt(i)) | 0;
	}
	return (hash >>> 0).toString(36);
};

const loaded = new Set();
const coreFiles = ["app", "ScrollTrigger", "TinyGesture"]; // Core js files without suffix , "inpage-menu"
//TODO: #12 Implement above the fold loading and onscroll loading
//, "utils/console-colors.js?c=" + BundleVersion
const dependencies = [
	["awards", ["ScrollTrigger.min.js?c=" + BundleVersion ]],
	["awards-events", ["ScrollTrigger.min.js?c=" + BundleVersion ]],
	["cta", ["ScrollTrigger.min.js?c=" + BundleVersion ]],
	["clients", ["ScrollTrigger.min.js?c=" + BundleVersion ]],
	["contact", ["ScrollTrigger.min.js?c=" + BundleVersion ]],
	["expertise", ["ScrollTrigger.min.js?c=" + BundleVersion,"state/state-manager.min.js?c=" + BundleVersion, "expertise.imgCarousel.min.js?c=" + BundleVersion, "utils/Valid/Valid-barebones.js?c=" + BundleVersion, "utils/utils.js?c=" + BundleVersion, "expertise.carousel.mobile.min.js?c=" + BundleVersion]],
	["hero", ["ScrollTrigger.min.js?c=" + BundleVersion ]],
	["inpage-menu", ["ScrollTrigger.min.js?c=" + BundleVersion,"state/state-manager.min.js?c=" + BundleVersion, "utils/utils.js?c=" + BundleVersion]],
	["images", ["ScrollTrigger.min.js?c=" + BundleVersion ]],
	["team", ["ScrollTrigger.min.js?c=" + BundleVersion,"utils/utils.js?c=" + BundleVersion]],
	["positions", ["ScrollTrigger.min.js?c=" + BundleVersion ]],
	["posts", ["ScrollTrigger.min.js?c=" + BundleVersion ]],
	["project", ["ScrollTrigger.min.js?c=" + BundleVersion, "hero.sh.min.js?c=" + BundleVersion, "hero.dt.min.js?c=" + BundleVersion]],
	["projects", ["ScrollTrigger.min.js?c=" + BundleVersion ]],
	["process", ["leader-line.min.js?c=" + BundleVersion,"ScrollTrigger.min.js?c=" + BundleVersion,"hero.sh.min.js?c=" + BundleVersion, "hero.dt.min.js?c=" + BundleVersion]],	
	["statistics", ["ScrollTrigger.min.js?c=" + BundleVersion ]],
	["services", ["ScrollTrigger.min.js?c=" + BundleVersion ]],
	["testimonials", ["ScrollTrigger.min.js?c=" + BundleVersion ]],
	["title-introduction", ["ScrollTrigger.min.js?c=" + BundleVersion ]],
];

const getDependencies = (key) => {
	return dependencies.find((dep) => dep[0] === key);
};

// Vite-compatible base path detection
const getBasePath = () => {
	// Use Vite's environment variables
	if (import.meta.env.VITE_PRODUCTION) {
		return "/wp-content/themes/fsw2025/dist/js/";
	}
	return "/wp-content/themes/fsw2025/dist/js/";
};

const basePath = getBasePath();

const suffixes = {
	desktop: ".dt.min.js",
	mobile: ".mb.min.js",
	// tablet: ".tb.min.js",
	shared: ".sh.min.js",
};
const isDesktop = window.matchMedia("(width >= 1025px)").matches;
const isTablet = window.matchMedia("(width < 1025px) and (width >= 768px)").matches;
const isMobile = !isDesktop && !isTablet;
const suffix = isDesktop ? suffixes.desktop : isTablet ? suffixes.desktop : suffixes.mobile;


const cacheVars = Date.now(); // 'nocache'; //BundleVersion ? hashCode(BundleVersion) : 'nocache';
// console.log("Cache vars: ", cacheVars);
const debug = false;

function _checkForScrollTrigger() {
	return window.ScrollTrigger;
}

function _setUpScrollTrigger() {
	gsap.registerPlugin(ScrollTrigger);
	ScrollTrigger.defaults({
		ease: "power3.out",
		markers: false,
		start: "top +=90%",
		end: "clamp(bottom bottom)",
		duration: 0.6,
	});
}


function _init() {

	_scrollTriggerLoaded = _checkForScrollTrigger();

	if (_scrollTriggerLoaded) {

		_setUpScrollTrigger();

	} else {

		let _loadScrollTriggerInterval = setInterval(() => {

			_scrollTriggerLoaded = _checkForScrollTrigger();

			if (_scrollTriggerLoaded) {
				_setUpScrollTrigger();
				clearInterval(_loadScrollTriggerInterval);


			} else {
				// console.log(" _scrollTriggerLoaded NOT LOADED: ");
			}
			// clearTimeout(_loadScrollTriggerInterval);
		}, 750);
	}
	coreFiles.forEach(file => {
		// Vite-compatible path resolution for core files
		const getCorePath = fileSuffix => {
			return `${basePath}${file}${fileSuffix}?v=${cacheVars}`;
		};

		const path = getCorePath(suffix);
		const pathShared = getCorePath(suffixes.shared);

		if (file && !loaded.has(path)) {
			loaded.add(path);

			loadScript(path, () => {
				debug && console.log("Loaded file:", path);
			});

			// shared files are always loaded
			loadScript(pathShared, () => {
				debug && console.log("Loaded shared file:", pathShared);
			});
		}
	});

	document.querySelectorAll(".layout[data-component]").forEach(layout => {

		// ----------------------------------------------------
		// Load dependency JS
		// ----------------------------------------------------
		const component = layout.getAttribute("data-component");
		const deps = getDependencies(component);

		if (!deps || deps.length < 2) return;
		deps[1]?.forEach((dep, i) => {

			const path = `${basePath}${dep}?v=${cacheVars}`;

			loadScript(path, () => {
				debug && console.log("Loaded component: ", component, " path ", path);
			});
		});
		// ----------------------------------------------------
		// Load component JS
		// ----------------------------------------------------
		
		loadComponentJavascript(component);

	});
}

function loadComponentJavascript(component) {

	// Vite-compatible path resolution
	const getComponentPath = fileSuffix => {
		return `${basePath}${component}${fileSuffix}?v=${cacheVars}`;
	};

	const path = getComponentPath(suffix);
	const pathShared = getComponentPath(suffixes.shared);

	if (component && !loaded.has(path)) {
		loaded.add(path);

		// Use script tag injection instead of dynamic imports for better compatibility
		loadScript(path, () => {
			debug && console.log("Loaded component: ", component, " path ", path);
		});

		loadScript(pathShared, () => {
			debug && console.log("Loaded shared component: ", component, " path", pathShared);
		});
	}
}

// Script loader function
function loadScript(src, onLoad) {
	return new Promise((resolve, reject) => {
		const script = document.createElement("script");
		script.src = src;
		script.type = "module";
		script.onload = () => {
			onLoad?.();
			resolve();
		};
		script.onerror = () => {
			console.log("Error loading script:", src);
			reject();
		};
		document.head.appendChild(script);
	});
}

let acfCheckInterval = null;

function checkForACF() {
	if (typeof acf !== "undefined") {
		acfListeners();
		clearInterval(acfCheckInterval);
	}
}

function acfListeners() {
	acf.addAction("new_field/name=layout_type", field => {
		if (field.val()) {
			const fieldNames = field
				.val()
				.split(",")
				.map(name => name.trim());

			fieldNames?.forEach(fieldName => {
				fieldName && loadComponentJavascript(fieldName);
			});
		}
	});
}

const addWindowListeners = () => {
	//--------------------------------------------------
	// Reload the page when breakpoint changes 
	// as assets are baked into the html
	//--------------------------------------------------
	let isDesktopBP = window.innerWidth >= 1025;
	let isTabletBP = window.innerWidth >= 768 && window.innerWidth < 1025;
	let isMobileBP = !isDesktopBP && !isTabletBP;
	let currentBreakpoint = isMobileBP ? "mobile" : isTabletBP ? "tablet" : "desktop";

	window.addEventListener("resize", () => {
		console.log("window resize");
		//--------------------------------------------------
		// only reload if the breakpoint has changed
		//--------------------------------------------------
		isDesktopBP = window.innerWidth >= 1025;
		isTabletBP = window.innerWidth > 768 && window.innerWidth < 1025;
		isMobileBP = !isDesktopBP && !isTabletBP;

		let newBreakpoint = isMobileBP ? "mobile" : isTabletBP ? "tablet" : "desktop";

		if (newBreakpoint === currentBreakpoint) return;
		currentBreakpoint = newBreakpoint;
		//--------------------------------------------------
		// reload the page on resize so that the correct
		// assets are loaded into the html
		//--------------------------------------------------
		const milli = String(Date.now());
		const hash = window.location.hash.split("?")[0];
		const url = 'https://' + window.location.hostname + window.location.pathname + "?rl=" + milli.substring(milli.length - 8) + hash;
		window.location.replace(url);
	});

}

if (document.readyState === "loading") {
	document.addEventListener("DOMContentLoaded", () => {
		acfCheckInterval = setInterval(checkForACF, 1000);
		addWindowListeners();
		_init();
	});
} else {

	acfCheckInterval = setInterval(checkForACF, 1000);
	addWindowListeners();
	_init();
}

